import { setDisplayName } from 'recompose';
import styled from 'styled-components';
import { Mono, Sans } from './core';

/** This is for inline code snippets and smaller code elements. */
export const Code01 = setDisplayName('Code01')(styled(Mono)`
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
  letter-spacing: 0.32px;
`);

/** This is for large code snippets and larger code elements. */
export const Code02 = setDisplayName('Code02')(styled(Code01)`
  font-size: 0.875rem;
  line-height: 1.25rem;
`);

/** This is for field labels in components and error messages. */
export const Label01 = setDisplayName('Label01')(styled(Sans)`
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
  letter-spacing: 0.32px;
`);

/**
 * This is for explanatory helper text that appears below a field title within a
 * component.
 */
export const HelperText01 = setDisplayName('HelperText01')(styled(Label01)``);
